import { useTranslation } from 'components/translation/TranslationProvider';
import { classNames } from 'libs/react';
import { useQuery } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { decode } from 'libs/util/json';
import { Button } from 'components/Button';
import { DropdownButton } from 'components/DropdownButton';
import { FieldGroupsValuesQuery } from 'graphql/FieldGroup/queries/FieldGroupsValuesQuery';
import { React } from 'libs/react';
import { FormInput } from 'components/form/FormInput';
import { gql } from '@apollo/client';
import './DealItemPickerQueryPredicate.scss';
/**
 * @component DealItemPickerQueryPredicate
 * @since 1.0.0
 */
export function DealItemPickerQueryPredicate(props) {
    const { name, style, title, value, prev, next } = Object.assign({ style: 'normal' }, props);
    const className = classNames('deal-item-picker-query-predicate', 'deal-item-picker-query-predicate--' + style, { 'deal-item-picker-query-predicate--has-prev': prev }, { 'deal-item-picker-query-predicate--has-next': next }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "deal-item-picker-query-predicate-body" },
            React.createElement(Button, { className: "deal-item-picker-query-predicate-prev", style: "picto", picto: "arrow-left", onPress: props.onPrev }),
            React.createElement(Button, { className: "deal-item-picker-query-predicate-next", style: "picto", picto: "arrow-right", onPress: props.onNext }),
            React.createElement("div", { className: "deal-item-picker-query-predicate-title" }, title),
            React.createElement("div", { className: "deal-item-picker-query-predicate-input" }, props.children))));
}
/**
 * @component DealItemPickerQuerySaleItemConfigurationPredicate
 * @since 1.0.0
 */
export function DealItemPickerQuerySaleItemConfigurationPredicate(props) {
    let { name, style, next, prev } = Object.assign({ style: 'normal' }, props);
    const placeholder = t('Select');
    const [value, setValue] = useState(props.value);
    if (next) {
        next = Boolean(value);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
    }
    useWatch(() => {
        if (props.onChange) {
            props.onChange(name, value);
        }
    }, [value]);
    const options = [
        {
            label: t('Configurable'),
            value: 'CONFIGURABLE'
        },
        {
            label: t('Inventory'),
            value: 'SIMPLE'
        },
        {
            label: t('Finished'),
            value: 'FINISHED'
        }
    ];
    const className = classNames('deal-item-picker-query-sale-item-group-predicate', 'deal-item-picker-query-sale-item-group-predicate--' + style, { 'deal-item-picker-query-sale-item-group-predicate--has-value': value }, props.className);
    return (React.createElement(DealItemPickerQueryPredicate, Object.assign({ className: className }, props, { next: next, prev: prev }),
        React.createElement(DropdownButton, { value: value, options: options, placeholder: placeholder, onSelect: onChange })));
}
/**
 * @component DealItemPickerQuerySaleItemGroupPredicate
 * @since 1.0.0
 */
export function DealItemPickerQuerySaleItemGroupPredicate(props) {
    var _a;
    let { name, style, next, prev } = Object.assign({ style: 'normal' }, props);
    const placeholder = t('Select');
    const [value, setValue] = useState(props.value);
    if (next) {
        next = Boolean(value);
    }
    const [data] = useQuery(gql `
      query SaleItemGroupsQuery($input: SaleItemGroupsInput) {
        saleItemGroups(input: $input) {
          id
          title
          useInQueryBuilder

          translations {
            id
            title
            infos

            language {
              id
              code
            }
          }
        }
      }
    `, {
        variables: {
            input: {
                entity: 'SALE_ITEM'
            }
        }
    });
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
    }
    useWatch(() => {
        if (props.onChange) {
            props.onChange(name, value);
        }
    }, [value]);
    const options = (_a = data === null || data === void 0 ? void 0 : data.saleItemGroups.filter((group) => group.useInQueryBuilder).map((entry) => {
        var _a;
        return {
            value: entry.id,
            label: entry.title,
            picto: (_a = entry.image) === null || _a === void 0 ? void 0 : _a.url
        };
    })) !== null && _a !== void 0 ? _a : [];
    // Add a default option
    options.unshift({
        value: 'all',
        label: t('All'),
        picto: ''
    });
    const className = classNames('deal-item-picker-query-sale-item-group-predicate', 'deal-item-picker-query-sale-item-group-predicate--' + style, { 'deal-item-picker-query-sale-item-group-predicate--has-value': value }, props.className);
    return (React.createElement(DealItemPickerQueryPredicate, Object.assign({ className: className }, props, { next: next, prev: prev }),
        React.createElement(DropdownButton, { value: value, options: options, placeholder: placeholder, onSelect: onChange })));
}
/**
 * @component DealItemPickerQuerySaleItemFieldPredicate
 * @since 1.0.0
 */
export function DealItemPickerQuerySaleItemFieldPredicate(props) {
    let { id, name, style, next, prev, inputType } = Object.assign({ style: 'normal' }, props);
    const placeholder = t('Select');
    const [value, setValue] = useState(props.value);
    const type = inputType == 'NUMBER' ? 'number' : 'text';
    if (next) {
        next = Boolean(value);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
    }
    useWatch(() => {
        if (props.onChange) {
            props.onChange(id, value);
        }
    }, [value]);
    const className = classNames('deal-item-picker-query-sale-item-price-predicate', 'deal-item-picker-query-sale-item-price-predicate--' + style, { 'deal-item-picker-query-sale-item-price-predicate--has-value': value }, props.className);
    return (React.createElement(DealItemPickerQueryPredicate, Object.assign({ className: className }, props, { next: next, prev: prev }),
        React.createElement(FormInput, { onChange: onChange, value: value, placeholder: placeholder, type: type })));
}
/**
 * @component DealItemPickerQuerySaleItemPricePredicate
 * @since 1.0.0
 */
export function DealItemPickerQuerySaleItemPricePredicate(props) {
    let { name, style, next, prev } = Object.assign({ style: 'normal' }, props);
    const [value, setValue] = useState(props.value);
    if (next) {
        next = Boolean(value);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(event) {
        setValue(event.currentTarget.value);
    }
    useWatch(() => {
        if (props.onChange) {
            props.onChange(name, value);
        }
    }, [value]);
    const className = classNames('deal-item-picker-query-sale-item-price-predicate', 'deal-item-picker-query-sale-item-price-predicate--' + style, { 'deal-item-picker-query-sale-item-price-predicate--has-value': value }, props.className);
    return (React.createElement(DealItemPickerQueryPredicate, Object.assign({ className: className }, props, { next: next, prev: prev }),
        React.createElement("input", { type: "text", value: value, onChange: onChange, onInput: onChange, placeholder: t('Enter') }),
        ' ',
        "$"));
}
/**
 * @component DealItemPickerQuerySaleItemSelectPredicate
 * @since 1.0.0
 */
export function DealItemPickerQuerySaleItemSelectPredicate(props) {
    let { id, name, style, next, prev, values } = Object.assign({ style: 'normal' }, props);
    const placeholder = t('Select');
    const { language } = useTranslation();
    const [value, setValue] = useState(props.value);
    if (next) {
        next = Boolean(value);
    }
    const [data, ready, error] = useQuery(FieldGroupsValuesQuery, {
        variables: {
            input: {
                query: [
                    {
                        field: 'category',
                        value: ['PRODUCT', 'VARIANT', 'PRODUCT_CONFIGURATION']
                    }
                ]
            }
        }
    });
    let groups = data === null || data === void 0 ? void 0 : data.fieldGroups;
    if (groups == null) {
        groups = [];
    }
    /**
     * @function toFields
     * @since 1.0.0
     * @hidden
     */
    function toFields(array, group) {
        /**
         * @function by
         * @since 1.0.0
         * @hidden
         */
        function by(field) {
            return field.name == name;
        }
        const items = group.fields.filter(by);
        return [...array, ...items];
    }
    /**
     * @function toChoices
     * @since 1.0.0
     * @hidden
     */
    function toChoices(array, field) {
        const { options } = field;
        if (options) {
            const items = decode(options).choices;
            if (items) {
                array.push(...items);
            }
        }
        if (values && field.id) {
            const availableValues = values.reduce((acc, item) => {
                var _a;
                const fieldValue = (_a = item.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fv) => fv.field.id === field.id);
                if (fieldValue) {
                    try {
                        const parsedValue = JSON.parse(fieldValue.value);
                        if (Array.isArray(parsedValue.value)) {
                            acc.push(...parsedValue.value);
                        }
                        else if (parsedValue.value) {
                            acc.push(parsedValue.value);
                        }
                    }
                    catch (e) {
                        console.error('Error parsing fieldValue:', e);
                    }
                }
                return acc;
            }, []);
            array = array.filter((option) => availableValues.includes(option.value));
        }
        // sort by order or value
        array.sort((a, b) => {
            if (a.order && b.order) {
                return a.order - b.order;
            }
            return a.value.localeCompare(b.value);
        });
        return array;
    }
    /**
     * @function toOptions
     * @since 1.0.0
     * @hidden
     */
    function toOptions(items, choice) {
        let { label, value, image } = choice;
        if (label instanceof Array) {
            let match = null;
            if (match == null)
                match = label.find((entry) => entry.language == language);
            if (match == null)
                match = label[0];
            if (match) {
                label = match.label;
            }
            else {
                label = t('Unlabeled');
            }
        }
        items.push({
            label,
            value
        });
        return items;
    }
    const options = groups
        .reduce(toFields, [])
        .reduce(toChoices, [])
        .reduce(toOptions, []);
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
    }
    useWatch(() => {
        if (props.onChange) {
            props.onChange(id, value);
        }
    }, [value]);
    const className = classNames('deal-item-picker-query-sale-item-price-predicate', 'deal-item-picker-query-sale-item-price-predicate--' + style, { 'deal-item-picker-query-sale-item-price-predicate--has-value': value }, props.className);
    return (React.createElement(DealItemPickerQueryPredicate, Object.assign({ className: className }, props, { next: next, prev: prev }),
        React.createElement(DropdownButton, { value: value, options: options, placeholder: placeholder, onSelect: onChange })));
}
